import { Box } from "@mui/material";
import { styled as muiStyled } from '@mui/material/styles';

export const AudioTranscriptionStyles = muiStyled(Box)(({ type, theme, $systemUI }) => ({
    display: "flex",
    columnGap: 20,
    flexDirection: "column",
    rowGap: 10,
    height: "100%",
    '.actions': {
        display: "flex",
        columnGap: 20,
        height: 100
    },
    '.content': {
        flexGrow: 1,
        display: "flex",
        alignItems: "center"
    }
}));
